// mutations.js
import $config from "@/config/config";

export const mutations = {  
    setAddr(state, newAddr) {  
        state.address = newAddr;  
    },
    async setChain(state, chainIndex) {  
        const targetChain = $config.CHAIN_LIST[chainIndex];
        if (!targetChain) {
            console.error("未知的链配置:", chainIndex);
            return;
        }
        const targetChainIdHex = targetChain.chainIdHex; // e.g. '0x1' or '0x38'
        const currentChainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
        if (currentChainIdHex !== targetChainIdHex) {
            try {
                await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: targetChainIdHex }],
                });
                console.log(`已切换到链: ${targetChain.title}`);
            }
            catch (switchError) {
                console.error("切换链失败:", switchError);
            }
        }
        state.chain = chainIndex;  
    },
    setLang(state, langIndex) {
        state.lang = langIndex;  
    },
    setUsers(state, Users) {  
        state.users = Users;  
    },
    setBalance(state, Balance) {  
        state.balance = Balance;  //注意这里设置的balance是前端的数据，用于和users.balance对比
    },
    /**
     * 通用方法：可以设置任意state：invite_code, kefu, bsc, eth, chain, token
     * store.commit('setState', {key: 'key', value: 'value'});
     * @param {*} state 
     * @param {*} param1 
     */
    setState(state, { key, value }) {
        state[key] = value;
    },
    
    // 设置钱包检测状态
    setWalletDetected(state, { detected, wallets }) {
        state.walletDetected = detected;
        state.detectedWallets = wallets;
    }
    // 可以在这里添加更多的 mutations  
};